 

import React from 'react';
import { RECOMMENDED_APPS } from '../messages/RecommendedAppConstants';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { Box, Tooltip } from '@mui/material';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import clsx from 'clsx';
import {
  cellStyles3,
  Columns,
  PDF,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { MADueDiligenceModalProps } from '../../_components/organisms/MADueDiligenceModal';
import { SnackbarState } from '../custom-hooks/Snackbar';
import { AlertColor as Color } from '@mui/material/Alert';
import {
  RowData,
  Section,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/SortableTable';
import { formatDate } from './helper';
import { ContractChipList } from '../../_components/atoms/ComparisonTable';
import { SubParameterDataType } from '../../_components/molecules/AddSubParameter';
//MA Due Diligence
//Types:

export type DueDiligenceDataType = {
  company_name: string;
  date_created: string;
  documents_uploaded: string[];
  parameters: string[];
  status: 'Ready' | 'In Progress' | 'Processing' | 'No Documents Uploaded';
  type_of_plan: string;
  eg_nid: string;
  vendor_type?: string;
};
export type DueDiligenceForGroupRowResultEvidenceDataType = {
  excerpt: string;
  document_section: string;
};
export type DueDiligenceForGroupRowResultDataType = {
  result: string;
  evidence: DueDiligenceForGroupRowResultEvidenceDataType[];
  confidence_score: 'high' | 'medium' | 'low';
  score_rationale: string;
  source: string;
};
export type DueDiligenceForGroupRowDataType = {
  answer: string;
  confidence_score: 'high' | 'medium' | 'low';
  description: string;
  parameter: string;
  score_rationale: string;
  result: DueDiligenceForGroupRowResultDataType[];
};
export type DueDiligenceForGroupDataType = {
  category: string;
  data: DueDiligenceForGroupRowDataType[];
};
export interface DueDiligenceContextType {
  loading: boolean;
  tableLoading: boolean;
  dueDiligenceData: DueDiligenceDataType;
  dueDiligenceForGroupData: DueDiligenceForGroupDataType[];
  selectedFilters: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<string[]>>;
  selectedParameters: string[];
  setselectedParameters: React.Dispatch<React.SetStateAction<string[]>>;
  selectedConfidenceScore: string[];
  setselectedConfidenceScore: React.Dispatch<React.SetStateAction<string[]>>;
  getDueDiligenceForGroup: (
    parameters: string[],
    confidenceScores: string[],
  ) => Promise<void>;
  parameters: string[];
  isDetailsModalOpen: boolean;
  setIsDetailsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  currentModalData: MADueDiligenceModalProps;
  setCurrentModalData: React.Dispatch<
    React.SetStateAction<MADueDiligenceModalProps>
  >;
}
export type LocationState = {
  eg_nid: string;
};

export type CategoryDataType = {
  category: string;
  description: string;
  key: string;
  name: string;
  type: string;
};
export type EditOptionsType = {
  parentRowId: number;
  subRowId?: number;
  mode: 'create' | 'edit';
};

export type AddProjectContextType = {
  egNid: string;
  setEgNid: React.Dispatch<React.SetStateAction<string>>;
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  uploadedFiles: File[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  stepLoading: boolean;
  setStepLoading: React.Dispatch<React.SetStateAction<boolean>>;
  companyName: string;
  setCompanyName: React.Dispatch<React.SetStateAction<string>>;
  typeOfPlan: string;
  setTypeOfPlan: React.Dispatch<React.SetStateAction<string>>;
  categoryData: CategoryDataType[];
  rows: RowData[] | Section[];
  setRows: React.Dispatch<React.SetStateAction<RowData[] | Section[]>>;
  openEditModal: boolean;
  setOpenEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedSubParameter: SubParameterDataType;
  setSelectedSubParameter: React.Dispatch<
    React.SetStateAction<SubParameterDataType>
  >;
  selectedEditOptions: EditOptionsType;
  setSelectedEditOptions: React.Dispatch<React.SetStateAction<EditOptionsType>>;
  handleSubParameterSave: () => void;
  snackbarState: SnackbarState;
  openSnackbar: (
    message: string,
    severity: Color,
    duration: number | null,
  ) => void;
  handleCloseSnackBar: () => void;
};

export type AddProjectTabProps = {
  currentTab: number;
};

export const formatComparisonTableData = (data: DueDiligenceDataType[]) => {
  const tableData: any[] = [];

  data.map((item: DueDiligenceDataType) => {
    const otherData = [];
    otherData.push(
      <Typography
        fontSize="14px"
        fontType="medium"
        textColor={patientAccessTheme.palette.text.highemphasis}
      >
        {formatDate(item?.date_created, 'YYYY-MM-DD')}
      </Typography>,
    );
    otherData.push(
      <Typography
        fontSize="14px"
        fontType="medium"
        textColor={patientAccessTheme.palette.text.highemphasis}
      >
        {item?.type_of_plan}
      </Typography>,
    );
    otherData.push(
      <ContractChipList selectedItems={item?.documents_uploaded} />,
    );
    otherData.push(<ContractChipList selectedItems={item?.parameters} />);

    tableData.push({
      company_name: item.company_name,
      eg_nid: item.eg_nid,
      status: item.status,
      otherData,
    });
  });
  return tableData;
};

export const filterParameters = (dueDiligenceForGroupData: any[]) => {
  return dueDiligenceForGroupData.map((item) => item?.category);
};

export const getConfidenceScoreOptions = () => {
  return Object.values(RECOMMENDED_APPS.MA_DUE_DILIGENCE.CONFIDENCE_SCORES);
};
export const getSelectedConfidenceScoreKeys = (values: string[]) => {
  const obj = RECOMMENDED_APPS.MA_DUE_DILIGENCE.CONFIDENCE_SCORES;
  return (Object.keys(obj) as Array<keyof typeof obj>).filter((key) =>
    values.includes(obj[key]),
  );
};

export const getRowColor = (confidence: string) => {
  switch (confidence) {
    case 'high':
      return '#E2F5F5';
    case 'medium':
      return '#FCEED9';
    case 'low':
      return '#F6E9E9';
    default:
      return '#FFFFFF';
  }
};
export const getConfidenceScoreColor = (confidence: string) => {
  switch (confidence) {
    case 'high':
      return '#1F7C7C';
    case 'medium':
      return '#C47F1C';
    case 'low':
      return '#B55454';
    default:
      return '#000000';
  }
};

export const MADueDiligenceInternalTableColumns: Columns[] = [
  {
    name: 'Parameters',
    width: '25%',
    align: 'left',
    cellStyles: cellStyles3,
  },
  { name: 'Data', width: '30%', align: 'left', cellStyles: cellStyles3 },
  { name: 'Rationale', width: '', align: 'left', cellStyles: cellStyles3 },
];
export const documentsTableColumns: Columns[] = [
  {
    name: 'Documents',
    width: '',
    align: 'left',
    cellStyles: cellStyles3,
  },
];

export const formatCategoryTableData = (
  data: DueDiligenceForGroupDataType[],
  classes: Record<string, string>,
  handleModalOpen: (data: MADueDiligenceModalProps) => void,
  isCategory?: boolean,
) => {
  const tableData: any[] = [];

  if (data.length > 0) {
    data.forEach((item) => {
      const eachRow: any[] = [];

      isCategory
        ? eachRow.push(
            <Typography fontSize="14px" fontType="medium" lineHeight="24px">
              {item.category}
            </Typography>,
          )
        : eachRow.push('');

      item.data.map((row: DueDiligenceForGroupRowDataType) => {
        const eachField = [];
        eachField.push(
          <Box className={classes.parameterBox}>
            <Typography
              fontSize="14px"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {row.parameter}
            </Typography>
            <Tooltip
              arrow
              classes={{
                tooltip: classes.tooltip,
                arrow: classes.arrow,
                popper: classes.popper,
              }}
              title={row.description}
              placement="bottom-start"
            >
              <InfoOutlinedIcon
                style={{
                  width: '18px',
                  height: '18px',
                  fill: patientAccessTheme.palette.status.icon,
                }}
              />
            </Tooltip>
          </Box>,
        );
        eachField.push(
          <Typography
            fontSize="14px"
            lineHeight="24px"
            className={classes.ellipsis}
            styleProps={{ width: '330px' }}
          >
            {row.answer}
          </Typography>,
        );
        eachField.push(
          <Typography
            fontSize="14px"
            lineHeight="24px"
            className={clsx(classes.ellipsis, classes.underline)}
            styleProps={{ width: '500px' }}
            onClick={() => {
              handleModalOpen({
                parameter: item.category,
                subParameter: row.parameter,
                question: row.description,
                confidenceScore: row.confidence_score,
                answer: row.answer,
                rationale: row.score_rationale,
                result: row.result,
              });
            }}
          >
            {row.score_rationale}
          </Typography>,
        );
        eachField.push(getRowColor(row.confidence_score));
        eachRow.push(eachField);
      });

      tableData.push(eachRow);
    });
  }
  return tableData;
};

export const formatCategoryTableModalData = (
  data: DueDiligenceForGroupRowResultDataType[],
) => {
  const tableData: any[] = [];

  data.forEach((row: DueDiligenceForGroupRowResultDataType) => {
    const eachRow: any[] = [];

    eachRow.push('');

    eachRow.push(
      <Typography
        fontSize="14px"
        fontType="regular"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {row.result}
      </Typography>,
    );
    eachRow.push(
      <Typography
        fontSize="14px"
        fontType="regular"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {`${row.source}/${row.evidence[0].document_section}`}
      </Typography>,
    );
    eachRow.push(
      <Typography
        fontSize="14px"
        fontType="regular"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {row.evidence[0].excerpt}
      </Typography>,
    );
    eachRow.push(
      <Typography
        fontSize="14px"
        fontType="regular"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {row.score_rationale}
      </Typography>,
    );
    eachRow.push(getRowColor(row.confidence_score));
    tableData.push(eachRow);
  });

  return tableData;
};

export const formatDocumentTableData = (data: string[]) => {
  return data.map((document) => [
    <Typography
      fontSize="14px"
      fontType="medium"
      textColor={patientAccessTheme.palette.text.highemphasis}
      styleProps={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
    >
      <PDF /> {document}
    </Typography>,
  ]);
};

export const extractCategory = (categoryData: CategoryDataType[]) => {
  const categories = categoryData.map((item) => item.category);
  return Array.from(new Set(categories));
};
export const formatRowsFromCategoryData = (
  data: CategoryDataType[],
  selectedCategories: string[],
): RowData[] => {
  // Group items by category
  const grouped = selectedCategories.map((categoryName, rowIndex) => {
    const subItems = data.filter((item) => item.category === categoryName);

    return {
      id: rowIndex + 1,
      name: categoryName,
      value: '',
      subrows: subItems.map((subItem, subIndex) => ({
        id: Number(`${rowIndex + 1}${subIndex + 1}`),
        name: subItem.name,
        value: subItem.description,
      })),
    };
  });

  return grouped;
};
